import { Theme, useMediaQuery } from "@suraasa/placebo-ui-legacy"
import BottomNavigation from "B2B/SuraasaSure/Navigation/BottomNavigation"
import TopNavigation from "B2B/SuraasaSure/Navigation/TopNavigation"
import ConfirmDialog, {
  ConfirmDialogProvider,
} from "components/AsyncDialog/ConfirmDialog"
import GlobalBanners from "features/GlobalBanners"
import GlobalCards from "features/GlobalCards"
import { SuraasaPlusAccessProvider } from "features/SuraasaPlus/context"
import { useTheme } from "react-jss"
import { Outlet, useSearchParams } from "react-router-dom"

const SuraasaSureAppLayout = () => {
  const theme = useTheme<Theme>()
  const mdUp = useMediaQuery(theme.breakpoints.up("md"))
  const [searchParams] = useSearchParams()
  const isApp = searchParams.get("suraasa-learn-app") === "true"

  return (
    <ConfirmDialogProvider>
      <SuraasaPlusAccessProvider>
        <ConfirmDialog />
        {!isApp && (
          <>
            <GlobalBanners />
            <TopNavigation />
            {!mdUp && <BottomNavigation />}
            <GlobalCards />
          </>
        )}
        {/* Do not put <BottomNavigation/> below <Outlet/> */}
        <div id="mainContent">
          <Outlet />
        </div>
      </SuraasaPlusAccessProvider>
    </ConfirmDialogProvider>
  )
}

export default SuraasaSureAppLayout
